<template>
  <div class="codeComp">

    <div class="box prelative">
      <div>VIP- oder Gutschein-Code eingeben:</div>

      <div class="pt-2 d-flex align-center">
        <v-text-field
          v-model="code"
          class="nolabel noMargin rounded100 whiteBg"
          placeholder=""
          illed hide-details
          required
          outlined
        ></v-text-field>
        <div>
          <v-btn
            class="btn-mini ml-1"
            @click.native.passive="checkCode">
            einlösen
            <!--                                <v-icon right class="myWhite">mdi-chevron-right</v-icon>-->
          </v-btn>
        </div>
      </div>

      <ListEnteredCodes
        v-if="showList"
      >
      </ListEnteredCodes>

      <BoxLoading
        v-if="loading"
      ></BoxLoading>

    </div>

  </div>
</template>


<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as xhr from '../api/xhr.js'
import * as util from '../vendor/util'
import * as qconst from '../vendor/qconstants';
import BoxLoading from "./BoxLoading";
import ListEnteredCodes from "./ListEnteredCodes";

export default {
  components: {ListEnteredCodes, BoxLoading},
  props: {
    label: {
      type: String,
      default: 'Dein Code'
    },
  },
  data() {
    return {
      loading: false,
      code: '',
      sperre: 0,
      sperrIv: null,
      showList: true,
    }
  },
  watch: {},
  mounted() {
    this.init();
  },
  // activated() {
  //     console.log('EnterCode activated...');
  //     this.init();
  // },
  methods: {
    init() {
      try {
        this.reset();
        this.initSperre();
        this.autoApplyEnteredCodes();
      } catch (e) {
        console.log('Error init enterCode: ' + e.message);
      }
    },
    initSperre() {
      if (this.sperrIv) {
        util.clearTheInterval(this.sperrIv);
      }
      this.sperrIv = setInterval(() => {
        if (this.sperre > 0) {
          this.sperre -= 1;
        }
      }, 1000);
    },
    autoApplyEnteredCodes() {
      let enteredCodes = this.$ls.get('enteredCodes', []);
      this.processApplicables(enteredCodes, true);
    },

    checkCode() {
      if (this.code.length < 3) {
        ebus.$emit('toast', 'Bitte gib zuerst einen Code ein');
        // ebus.$emit('showInfo', {
        //     title: 'Bitte gib zuerst einen Code ein',
        //     text: ''
        // });
        return
      }
      if (this.sperre > 30) {
        ebus.$emit('toast', 'Die Code-Eingabe ist für 20 Sekunden gesperrt');
        return;
      }
      this.loading = true;
      let msg = {
        action: qconst.action$LoadCoupons,
        code: '' + this.code,
      };
      xhr.xhrSend(true, msg, (reply) => {
        this.loading = false;
        if (reply.ok) {
          console.log('einlösen: reply coupons ok: ' + JSON.stringify(reply));

          try {
            if (reply.coupons) {
              let applicableCoupons = [];
              let gutscheine = [];

              for (let c of reply.coupons) {
                if (!c.active) {
                  continue;
                }
                if (c.validUntil < Date.now()) {
                  continue;
                }
                if (c.applicable) {
                  applicableCoupons.push(c);
                } else {
                  gutscheine.push(c);
                }
              }

              //apply only the one entered by the user
              let filteredApplicable = applicableCoupons.filter(c => c.couponCode === this.code);
              let filteredGutscheine = gutscheine.filter(c => c.couponCode === this.code);

              console.log('einlösen: number of filteredApplicable: ' + filteredApplicable.length);
              console.log('einlösen: number of filteredGutscheine: ' + filteredGutscheine.length);

              let any = false;
              if (filteredApplicable.length > 0) {
                any = true;
                this.processApplicables(filteredApplicable, false);
              }
              if (filteredGutscheine.length > 0) {
                any = true;
                this.processGutscheine(filteredGutscheine);
              }
              if (!any) {
                this.showUngueltig();
              }
            } else {
              this.showUngueltig();
            }
          } catch (e) {
            ebus.$emit('error',
              'Code Evaluierungsfehler', e.message);

            console.log('einlösen: Evaluierungsfehler: ' + e.message);
          }


        } else {
          console.log('reply coupons not ok');
        }
      }, (err) => {
        this.loading = true;
        console.log('??? error in checkCode: ' + err.message);
      });
    },

    showUngueltig() {
      ebus.$emit('toast', 'Der eingegebene Code is ungültig');
      this.sperre += 30; //seconden
    },

    processGutscheine(coupons) {
      let alreadyAppliedCodes = [];
      for (let c of coupons) {
        //add gutschein tu the cart
        c.isCoupon = true;
        c.count = 1;
        c.cartItemId = util.generateClientId();
        // c.nameToDisplay = 'Gutschein';
        c.forRedeem = true; // Unterscheidung zwischen Gutschein kaufen und Gutschein einlösen
        c.aaaCodeTitle = c.title;
        store.commit('addItemToCart', {item: c});

        ebus.$emit('showInfo', {
          title: 'Der eingegebene Code ist gültig für "' + c.title + '"',
          text: 'Der Warenkorb wurde entsprechend aktualisiert'
        });

      }
    },

    processApplicables(coupons, auto) {
      let alreadyAppliedCodes = [];
      for (let c of coupons) {

        let code = c.couponCode;

        if (!c.allowMulti) {
          if (alreadyAppliedCodes.includes(code)) {
            continue;
          } else {
            alreadyAppliedCodes.push(c.couponCode);
          }
        }

        this.applyToItems(c, auto);
      }
      if (auto) {
        console.log('einlösen: auto applied codes: ' + JSON.stringify(coupons));
      }
    },

    applyToItems(coupon, auto) {
      if (coupon.validUntil < Date.now()) {
        console.log('einlösen: ignore coupon because it is no longer valid');
        return;
      }
      let codeToApply = coupon.couponCode;
      console.log('einlösen: applyToItems... couponCode: ' + codeToApply);
      for (let bundelItem of coupon.bundle) {


        let amountFree = 0;
        if (coupon.type === 'amount') {
          amountFree = parseFloat(coupon.amount);
        }

        let firstTime = true;
        for (let cartItem of store.getters.cartItems) {

          try {
            if (cartItem.id === bundelItem.id) {
              // if (item.offered) {
              //     continue;
              // }

              let cartVol = cartItem.vol;
              if (('' + cartVol) === ('' + bundelItem.vol)) {

                //do not apply  multiple codes to the sam item
                // if (cartItem.appliedCode && !coupon.combinable) {
                //     console.log('einlösen: Der Code "' + this.code + '" ist nicht kombinierbar');
                //     if (firstTime) {
                //         firstTime = false;
                //         ebus.$emit('toast', 'Der Code "' + this.code + '" wurde bereits eingelöst');
                //     }
                //     continue;
                // }

                //do not apply the same code twice
                if (cartItem.appliedCode && cartItem.appliedCode === codeToApply) {
                  console.log('einlösen: Der Code "' + codeToApply + '" wurde bereits eingelöst extras: ' + cartItem.extrasToDisplay);
                  if (!auto) {
                    ebus.$emit('toast', 'Der Code "' + codeToApply + '" wurde bereits eingelöst');
                  }
                  continue;
                }

                //Here the actual apply takes place
                let cartSizePrice = 0 + cartItem.sizePrice;
                console.log('einlösen: now apply the rabatt to the item... extras: ' + cartItem.extrasToDisplay);

                let cartItemUpdates = {
                  originalSizePrice: cartSizePrice,
                  originalItemTotal: 0 + cartItem.itemTotal,
                  appliedCode: codeToApply,
                  aaaCodeTitle: coupon.title,
                };
                if (amountFree !== 0) {
                  if (coupon.fixedprice && amountFree < cartSizePrice) {
                    amountFree = cartItem.sizePrice - amountFree;
                  }
                  cartItemUpdates.sizePrice = cartSizePrice - amountFree;
                } else {
                  cartItemUpdates.sizePrice = util.roundToTwo(cartSizePrice * (100 - coupon.discount) / 100);
                }

                //CART ITEM PROPS:
                // sizePrice: sizePrice,
                // sumOfExtras: sizePrices.sumOfExtras,// this.total - (size.price * size.aaaCount),
                // itemTotal: sizePrices.sizeTotal + sizePrices.sumOfExtras,
                // count: size.aaaCount,

                //reinit itemTotal
                let iTotal = cartItemUpdates.sizePrice * cartItem.count + cartItem.sumOfExtras;
                cartItemUpdates.itemTotal = iTotal;

                let propsToUpdate = {
                  appliedCode: coupon.couponCode,
                  aaaCodeTitle: coupon.title,
                  amountFree: amountFree,
                  amountFreeTotal: amountFree * cartItem.count,
                };

                Object.assign(propsToUpdate, cartItemUpdates);

                //do update the cartItem in the store
                let update = {
                  cartItemId: cartItem.cartItemId,
                  propsToUpdate: propsToUpdate,
                };

                console.log('einlösen: update: ' + JSON.stringify(update));
                store.commit('updateCartItem', update);

                if (!auto) {
                  ebus.$emit('showInfo', {
                    title: 'Der Code für "' + coupon.title + '" wurde erfolgreich eingelöst',
                    text: 'Der Warenkorb wurde entsprechend aktualisiert'
                  });
                  // util.rerender(this.showList);
                  // this.showList = false;
                  // setTimeout(()=>{
                  //     this.showList = true;
                  // },400);
                }

                //store the code in the ls
                let enteredCodes = this.$ls.get('enteredCodes', []);
                let isNew = true;
                for (let ec of enteredCodes) {
                  if (ec.couponCode === coupon.couponCode) {
                    isNew = false;
                  }
                }
                if (isNew) {
                  enteredCodes.push(coupon);
                }
                let exp = 180 * 24 * 60 * 60 * 1000; //180 days
                if (coupon.saveForDays) {
                  exp = coupon.saveForDays * (24 * 60 * 60 * 1000);
                }
                this.$ls.set('enteredCodes', enteredCodes, exp);

              } // eof vol match

            }
          } catch (e) {
            console.log('einlösen error in applyToItems: ' + e.message);
          }


        }// eof cartItems loop
      }
    },

    reset() {
      this.code = '';
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/base';

.codeComp {
  display: inline-block;

  .box {
    border-radius: $box-border-radius;
    display: inline-block;
    padding: 20px;
    background-color: $color-gray;
    @include text-contrast($color-gray);
    border: 1px solid black;
  }

  .btn-mini {
    padding: 0 !important;
  }
}

.codeComp ::v-deep .v-text-field .v-input__slot {
  overflow: hidden;
  //border: 1px solid #666;
  /*min-height: 60px;*/
  padding: 4px 0 4px 10px;
}


.codeComp ::v-deep .v-input {
  font-size: $fontSize;
  margin-top: 0;
  padding-top: 0;
}

.codeComp ::v-deep .v-input__append-inner {
  margin-top: 4px;
}

.codeComp ::v-deep .v-text-field .v-label {
  top: 20px;
}

.codeComp ::v-deep input {
  padding: 14px 0 0 0;
}


.codeComp .nolabel ::v-deep input {
  padding: 0;
  margin: 7px 4px 7px 0;
}


.codeComp ::v-deep .v-input__slot:before {
  border: none;
}

.codeComp ::v-deep .v-input__append-inner {
  margin-top: 6px;
}

</style>
